var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.32 5.05006L15.32 3.05005H15.25C15.2035 3.04538 15.1566 3.04538 15.11 3.05005H14.88H14.75H14.68L9 5.00005L3.32 3.05005C3.16962 3.00047 3.00961 2.9873 2.85314 3.01164C2.69667 3.03598 2.54822 3.09713 2.42 3.19005C2.29076 3.28207 2.18527 3.40352 2.11224 3.54436C2.03921 3.68521 2.00074 3.8414 2 4.00005V18.0001C1.99946 18.2097 2.06482 18.4142 2.18685 18.5847C2.30887 18.7552 2.48138 18.883 2.68 18.9501L8.68 20.9501C8.88145 21.0157 9.09856 21.0157 9.3 20.9501L15 19.0501L20.68 21.0001C20.7862 21.0145 20.8938 21.0145 21 21.0001C21.2091 21.003 21.4132 20.9361 21.58 20.8101C21.7092 20.718 21.8147 20.5966 21.8878 20.4557C21.9608 20.3149 21.9993 20.1587 22 20.0001V6.00005C22.0005 5.79041 21.9352 5.5859 21.8132 5.41543C21.6911 5.24495 21.5186 5.11714 21.32 5.05006ZM8 18.6101L4 17.2801V5.39005L8 6.72005V18.6101ZM14 17.2801L10 18.6101V6.72005L14 5.39005V17.2801ZM20 18.6101L16 17.2801V5.39005L20 6.72005V18.6101Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap1);
export default __webpack_public_path__ + "static/media/map1.7785ce93a13bfd5cb52525176eb56dfe.svg";
export { ForwardRef as ReactComponent };